import { atom } from 'jotai';

import { DTODownloadableContentInfoEntry } from 'src/apis/dto/DTODownloadableContentInfo';

import { getDownloadableContentsAPI } from './apis';

export const downloadableContentsAtom = atom<DTODownloadableContentInfoEntry[]>([]);

export const fetchDownloadableContentsAtom = atom(null, async (_get, set) => {
  const res = await getDownloadableContentsAPI();
  set(downloadableContentsAtom, res.data.result.entries);
});
